import { render, staticRenderFns } from "./NetbarSoftware.vue?vue&type=template&id=3065236c&"
import script from "./NetbarSoftware.vue?vue&type=script&lang=js&"
export * from "./NetbarSoftware.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports